/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-checkbox-undeterminate': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M6.25 8.75h7.5v2.5h-7.5v-2.5zm10-6.25H3.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25zM3.75 16.25V3.75h12.5v12.5H3.75z"/>'
  }
})
